import { render, staticRenderFns } from "./PtPageNotFound.vue?vue&type=template&id=2248cccc"
import script from "./PtPageNotFound.vue?vue&type=script&lang=js"
export * from "./PtPageNotFound.vue?vue&type=script&lang=js"
import style0 from "./PtPageNotFound.vue?vue&type=style&index=0&id=2248cccc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports